// Change website animations
const animation = {
  // make it false to switch off fade-up animation
  animate: true,
  // animation playing duration
  duration: 750,
  // if true, animation plays only once when element comes on screen
  once: false,


};
// Change your display name on tha landing display
const header = {
  name: "Monika Kumari",
};
const background = {
  // Options: Snow or Particle
  type: "Snow",
};
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const section2title = "About Me";
const about = {
  paragraph:
    "I am a full stack web developer student at Masai School. I also have interest in frontend libraies. Fully committed to designing and developing innovative web-based materials that users will love. Always eager to learn new things. Looking apart from programming you will find me listening music and painting 🎨 🖌. ",
};
// Edit your skill and the percentage you know about it
// To Add a skill, copy any one below and paste it after the last comma
const skillsBar = [
  // {
  //   name: "HTML5",
  //   // To add a custom svg instead of font-awesome icons, add svg path below otherwise just comment it out
  //   svg: "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z",
  //   faClass: "fab fa-html5",
  // },
  // {
  //   name: "CSS3",
  //   // svg: '',
  //   faClass: "fab fa-css3",
  // },
  // {
  //   name: "Javascript",
  //   // svg: '',
  //   faClass: "fab fa-js",
  // },
  // {
  //   name: "Node",
  //   // svg: '',
  //   faClass: "fab fa-node",
  // },
  // {
  //   name: "Database",
  //   // svg: '',
  //   faClass: "fas fa-database",
  // },
  // {
  //   name: "AWS",
  //   // svg: '',
  //   faClass: "fab fa-aws",
  // },
];
// Edit your projects, its name, your skills used to make it, and the url.
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number

// Edit your Miscellaneous Activities, its name and the url.
// You can omit freely anything if you dont have it
// To Add a Activity, copy any one below and paste it after the last comma and increment the id's Miscellaneous number
const section4Title = "Skills";
const miscellaneous = [
  {
    // Add image in './styles/images.css' in #misc1
    id: "misc1",
    name: "HTML",
    url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
  },
  {
    // Add image in './styles/images.css' in #misc2
    id: "misc2",
    name: "CSS",
    url: "https://raw.githubusercontent.com/github/explore/6c6508f34230f0ac0d49e847a326429eefbfc030/topics/css/css.png",
  },
  {
    // Add image in './styles/images.css' in #misc3
    id: "misc3",
    name: "JavaScript",
    url: "https://icons-for-free.com/iconfiles/png/512/javascript+js+node+icon-1320184811019773066.png",
  },
  {
    // Add image in './styles/images.css' in #misc3
    id: "misc4",
    name: "NodeJs",
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6adR66I46lYByAyL7dJjuuX1FPtlh00McLLA_oO-MenkTSRuyJqCVZw-ovkr32Wx2fo4&usqp=CAU",
  },
  {
    // Add image in './styles/images.css' in #misc3
    id: "misc5",
    name: "React",
    url: "https://icons-for-free.com/iconfiles/png/512/logo+react+react+js+icon-1320184811840217251.png",
  },
  {
    // Add image in './styles/images.css' in #misc3
    id: "misc6",
    name: "C++",
    url: "https://amenys.com/wp-content/uploads/2020/02/c.png",
  },
];
const section3Title = "Past Projects";
const projects = [
  {
    // Add image in './styles/images.css' in #project1
    id: "project1",
    name: "JioMart",
    skills: ["Tech:- HTML, CSS, JS    "],
    des: "   JioMart is an Indian e-commerce company, headquartered in Navi India, Reliance Retail and Jio Platforms.",
    url: "https://loving-euler-653170.netlify.app/",
    target: "_blank",
    url1: "https://github.com/arundhathi6/Jiomart",
  },
  {
    // Add image in './styles/images.css' in #project2
    id: "project2",
    name: "HealthKart",
    skills: ["Tech:- HTML, CSS, JS, LocalStorage "],
    des: "  HealthKart is an online health and fitness store for men and women, which offers fitness products, services and community.",
    url: "https://unit3-healthkart-clone-app.netlify.app/",
    url1: "https://github.com/GreatA-Maker/HealthKart",
  },
  {
    // Add image in './styles/images.css' in #project3
    id: "project3",
    img: "https://drive.google.com/file/d/1Y3zszfEccdEGxGFnOCe5O7EXfhDyZN-f/view?usp=sharing",
    name: "HealthKart_Backend ",
    skills: ["Tech:- HTML, CSS, JS, NodeJs, MangoDb "],
    des: " HealthKart is an online health and fitness store for men and women, which offers fitness products, services and community.",
    url: "https://unit3-healthkart-clone-app.netlify.app/",
    target: "_blank",
    url1: "https://github.com/Premkumar-hulikoppe/Construct_Week_HealthKart_Backend.git",
  },

  {
    // Add image in './styles/images.css' in #project3
    id: "project4",
    img: "https://drive.google.com/file/d/1Y3zszfEccdEGxGFnOCe5O7EXfhDyZN-f/view?usp=sharing",
    name: "Airbnb - Clone  ",
    skills: ["Tech:- Material UI, SCC, React, Redux, Context API"],
    des: " Airbnb, Inc. is an American company that operates an online marketplace for lodging, primarily homestays for vacation rentals, and tourism activities.",
    url: "https://airbnb-clone-snowy-three.vercel.app/",
    target: "_blank",
    url1: "https://github.com/Jerry-29/Airbnb-Clone/tree/Rohit_airnb/airbnrohit/src/components",
  },
];
// Contact form text, and Formspree link(to send a submit contact through their API as in contact.js)
// To get your own jotform link, go to https://formspree.io/
// If you hacve the link already, paste it in the contactUrl below
const section5Title = "Get in Touch";
const contact = {
  pitch: "",
  copyright: "Monika Kumari",
  contactUrl: "https://formspree.io/f/mjvlwwyg",
};
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
  github: "https://github.com/monika-4oop",
  target: "_blank",
  Gmail: "kmonika9407@gmail.com",
  phone: "7004097649",
  instagram: "https://instagram.com/monica07940",
  target: "_blank",
  linkedin: "https://www.linkedin.com/in/monika-kumari-84525a128/",
  target: "_blank",
  resume:
    "https://drive.google.com/file/d/1oX3ggZgt60raClY_DwRHXYj7htVHoFqF/view?usp=sharing",
  target: "_blank",
};
// Dont change anything here
export {
  animation,
  header,
  background,
  about,
  skillsBar,
  projects,
  miscellaneous,
  contact,
  social,
  section2title,
  section4Title,
  section3Title,
  section5Title,
};
